/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum to capture the different types of UX events we track.
 */
export var InteractionEventType;
(function (InteractionEventType) {
    InteractionEventType["BLUEPRINT"] = "blueprint";
    InteractionEventType["APP"] = "app";
})(InteractionEventType || (InteractionEventType = {}));
